import { TextField } from "@mui/material";
import styled from "styled-components";

export const Input = styled(TextField)``;
